var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var getErrorMessage = function (e) {
    return e.stack || e.message;
};
var appendToStack = function (stack, moreInfo) {
    return "".concat(stack, "\n\n").concat(moreInfo);
};
var SiteAssetsClientError = /** @class */ (function (_super) {
    __extends(SiteAssetsClientError, _super);
    function SiteAssetsClientError(message, errorOptions) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        _this.name = _this.constructor.name;
        if (errorOptions && errorOptions.cause) {
            _this.cause = errorOptions.cause;
            _this.stack = appendToStack(_this.stack, "Caused By: ".concat(getErrorMessage(_this.cause)));
        }
        return _this;
    }
    return SiteAssetsClientError;
}(Error));
export { SiteAssetsClientError };
var HttpClientFetchError = /** @class */ (function (_super) {
    __extends(HttpClientFetchError, _super);
    function HttpClientFetchError(message, cause) {
        return _super.call(this, message, { cause: cause }) || this;
    }
    return HttpClientFetchError;
}(SiteAssetsClientError));
export { HttpClientFetchError };
var UnexpectedHttpClientError = /** @class */ (function (_super) {
    __extends(UnexpectedHttpClientError, _super);
    function UnexpectedHttpClientError(cause) {
        return _super.call(this, 'http client unexpectedly threw an error', { cause: cause }) || this;
    }
    return UnexpectedHttpClientError;
}(SiteAssetsClientError));
export { UnexpectedHttpClientError };
var InvalidServerResponse = /** @class */ (function (_super) {
    __extends(InvalidServerResponse, _super);
    function InvalidServerResponse(message) {
        return _super.call(this, message) || this;
    }
    return InvalidServerResponse;
}(SiteAssetsClientError));
export { InvalidServerResponse };
var UrlBuilderError = /** @class */ (function (_super) {
    __extends(UrlBuilderError, _super);
    function UrlBuilderError(cause) {
        return _super.call(this, 'SITE-ASSETS URL BUILDER FAILED', { cause: cause }) || this;
    }
    return UrlBuilderError;
}(SiteAssetsClientError));
export { UrlBuilderError };
function getErrorMessageWithShortUrl(url, cause) {
    var message = cause.message;
    // if the message includes the url, truncate it, since it can get very long
    var messageWithShortUrl = (url && message.includes(url)) ? message.replace(url, "".concat(url.substring(0, 120), "...")) : message;
    return "[SAC] ".concat(messageWithShortUrl);
}
var SiteAssetsServerError = /** @class */ (function (_super) {
    __extends(SiteAssetsServerError, _super);
    function SiteAssetsServerError(siteAssetsUrl, cause) {
        var _this = _super.call(this, getErrorMessageWithShortUrl(siteAssetsUrl, cause), { cause: cause }) || this;
        _this.stack = appendToStack(_this.stack, "URL: ".concat(siteAssetsUrl));
        return _this;
    }
    return SiteAssetsServerError;
}(SiteAssetsClientError));
export { SiteAssetsServerError };
var SiteAssetsFallbackError = /** @class */ (function (_super) {
    __extends(SiteAssetsFallbackError, _super);
    function SiteAssetsFallbackError(cause, siteAssetsServerError) {
        var _this = _super.call(this, cause.message, { cause: cause }) || this;
        if (siteAssetsServerError) {
            _this.stack = appendToStack(_this.stack, "".concat(siteAssetsServerError.stack));
        }
        return _this;
    }
    return SiteAssetsFallbackError;
}(SiteAssetsClientError));
export { SiteAssetsFallbackError };
var SiteAssetsClientValidationError = /** @class */ (function (_super) {
    __extends(SiteAssetsClientValidationError, _super);
    function SiteAssetsClientValidationError(message) {
        return _super.call(this, message) || this;
    }
    return SiteAssetsClientValidationError;
}(SiteAssetsClientError));
export { SiteAssetsClientValidationError };
var SiteAssetsLoadModuleExecutorError = /** @class */ (function (_super) {
    __extends(SiteAssetsLoadModuleExecutorError, _super);
    function SiteAssetsLoadModuleExecutorError(cause) {
        return _super.call(this, 'SITE-ASSETS FAILED TO LOAD MODULE EXECUTOR', { cause: cause }) || this;
    }
    return SiteAssetsLoadModuleExecutorError;
}(SiteAssetsClientError));
export { SiteAssetsLoadModuleExecutorError };
var SiteAssetsClientSpecMapSupplierError = /** @class */ (function (_super) {
    __extends(SiteAssetsClientSpecMapSupplierError, _super);
    function SiteAssetsClientSpecMapSupplierError() {
        return _super.call(this, 'Must send clientSpecMap or clientSpecMapSupplier') || this;
    }
    return SiteAssetsClientSpecMapSupplierError;
}(SiteAssetsClientError));
export { SiteAssetsClientSpecMapSupplierError };
